import {Alert, Box, Snackbar, useTheme} from "@mui/material";
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import CircleIcon from '@mui/icons-material/Circle';
import CircularProgress from '@mui/material/CircularProgress';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import {useContext, useEffect, useState} from "react";
import {setSnackbar} from "../state/globalAction";
import {snackbarTypes} from "../state/globalVariables";
import {GlobalContext} from "../state/GlobalContextProvider";

const CustomSnackbar = () => {
    const {globalData, dispatchGlobalData} = useContext(GlobalContext);
    const [content, setContent] = useState<any>({icon: null, message: ''});

    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        dispatchGlobalData({
            type: setSnackbar,
            payload: {
                snackbar: {
                    show: false,
                }
            }
        });
    };

    useEffect(() => {
        switch (globalData.snackbar.type) {
            case snackbarTypes.success:
                setContent({
                    icon: <Box><CircleIcon style={{color: 'white', width: '22px', height: '22px'}}/>
                        <CheckCircleRoundedIcon color={'success'}
                                                style={{position: 'absolute', left: '15px', top: '14px'}}/></Box>,
                    message: globalData.snackbar.message
                });
                break;
            case snackbarTypes.error:
                setContent({
                    icon: <Box><CircleIcon style={{color: 'white', width: '22px', height: '22px'}}/> <ErrorRoundedIcon
                        color={'error'} style={{position: 'absolute', left: '15px', top: '14px'}}/></Box>,
                    message: globalData.snackbar.message
                });
                break;
            case snackbarTypes.warning:
                setContent({
                    icon: <Box><WarningAmberRoundedIcon style={{color: 'white', width: '22px', height: '22px'}}/>
                        <WarningRoundedIcon color={'warning'} style={{
                            position: 'absolute',
                            left: '15px',
                            top: '14px'
                        }}/></Box>,
                    message: globalData.snackbar.message
                });
                break;
            case snackbarTypes.info:
                setContent({
                    icon: <Box><CircleIcon style={{color: 'white', width: '22px', height: '22px'}}/> <InfoRoundedIcon
                        color={'info'} style={{position: 'absolute', left: '15px', top: '14px'}}/></Box>,
                    message: globalData.snackbar.message
                });
                break;
            case snackbarTypes.loading:
                setContent({
                    icon: <Box><CircularProgress variant="determinate" sx={{color: 'white'}} value={100}
                                                 size={24}/><CircularProgress variant="indeterminate" disableShrink
                                                                              color="accent" sx={{
                        position: 'absolute',
                        left: '16px'
                    }} size={24}/></Box>, message: globalData.snackbar.message
                });
                break;
        }
    }, [globalData.snackbar])

    return (
        <Snackbar
            open={globalData.snackbar.show}
            autoHideDuration={5000}
            onClose={handleClose}
            id={'custom-snackbar'}
        >
            <Alert icon={content.icon} sx={{
                backgroundColor: useTheme().palette.primary.main,
                color: useTheme().palette.primary.contrastText,
                width: '100%',
                borderRadius: '10px',
                whiteSpace: 'break-spaces'
            }}

            >
                {content.message}
            </Alert>
        </Snackbar>
    );
}

export default CustomSnackbar;
